import { useEffect, useRef } from 'react';

/**
 * Logs an experiment exposure the first time `isEligible` turns true.
 *
 * `useVariant`'s built-in immediate logging can't be used for page-level
 * experiments: it fires as soon as the variant resolves, before the page knows
 * whether it redirected away, and regardless of per-variant eligibility. This
 * waits for the caller's gate and then latches, so a re-render (or a dependency
 * identity change) can't log a second exposure for the same mount.
 */
export const useLogExposureOnce = (isEligible: boolean, logExposure: () => void) => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (isEligible && !hasLoggedRef.current) {
      hasLoggedRef.current = true;
      logExposure();
    }
  }, [isEligible, logExposure]);
};
